import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from '@env';
import { TRANSLOCO_SCOPE } from '@ngneat/transloco';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { delay, filter, Subject, takeUntil } from 'rxjs';
import { CommonUtilsService } from '../../services/commonutils/common-utils.service';
import { UtilsService } from '../../services/utils/utils.service';

import { CreateServiceBulkReportsDownloadRequest, GetServiceTransformations, SetBulkReportsDownloadRequest } from '../../store/actions';
import { getCustomCurrentOrganization$, getServiceOutBoundTransformations$ } from '../../store/selectors';

@Component({
    selector: 'app-download-bulk-reports-dialog',
    templateUrl: './download-bulk-reports-dialog.component.html',
    styleUrls: ['./download-bulk-reports-dialog.component.scss'],
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            useValue: '',
        },
    ],
    standalone: false,
})
export class DownloadBulkReportsDialogComponent implements OnDestroy, OnInit {
    @Input() public serviceId: string;
    @Input() public restApiName: string;
    @Input() public selectedInstanceIds: string[];

    private unSubscribe = new Subject<void>();
    public selectedTransformationNames: any;
    public outBoundTransformations: any;
    public currentOrganization: any;

    constructor(
        private store$: Store,
        private dialogRef: MatDialogRef<DownloadBulkReportsDialogComponent>,
        private actions$: Actions,
        private _utils: UtilsService
    ) {}

    private getTransformations = () => {
        this.store$.dispatch(GetServiceTransformations({ serviceId: this.serviceId, restApiName: this.restApiName }));
    };

    public closeModal = () => {
        this.dialogRef.close();
    };

    public createDownloadRequest = () => {
        this.store$.dispatch(
            CreateServiceBulkReportsDownloadRequest({
                serviceId: this.serviceId,
                transformationNames: this.selectedTransformationNames,
                instanceIds: this.selectedInstanceIds,
            })
        );
    };

    ngOnInit(): void {
        this.store$
            .select(getCustomCurrentOrganization$)
            .pipe(takeUntil(this.unSubscribe))
            .subscribe(organization => {
                this.currentOrganization = organization;
            });

        this.store$
            .select(getServiceOutBoundTransformations$(this.serviceId))
            .pipe(
                takeUntil(this.unSubscribe),
                filter(transformations => transformations !== undefined),
                delay(500)
            )
            .subscribe((transformations: any) => {
                this.outBoundTransformations = CommonUtilsService.cloneObject(transformations);
            });

        this.actions$
            .pipe(
                ofType(SetBulkReportsDownloadRequest),
                takeUntil(this.unSubscribe),
                filter(action => action.serviceId === this.serviceId),
                delay(100)
            )
            .subscribe(res => {
                if (res?.downloadUrl) {
                    const url =
                        environment.taxilla_api +
                        '/process/v1/files?fileUrl=' +
                        encodeURIComponent(res?.downloadUrl) +
                        '&fileName=' +
                        encodeURIComponent('reports.zip');
                    this._utils.openUrlInNewTab(url);
                }
            });

        this.getTransformations();
    }

    ngOnDestroy(): void {
        this.unSubscribe.next();
        this.unSubscribe.complete();
    }
}
